import { Button, Menu } from "antd";
import { useAuth } from "AuthContext";
import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
    LogoutOutlined,
    UserOutlined,
    LoginOutlined,
    ApartmentOutlined,
} from "@ant-design/icons";
import { theme } from 'antd';
import NotificationButton from "components/general/NotificationButton";

const { useToken } = theme;

function Navigation({ items }) {
    const navigate = useNavigate();
    const location = useLocation();
    return (
        <Menu
            onClick={(e) => {
                navigate(e.key);
            }}
            mode="horizontal"
            items={items}
            selectedKeys={location.pathname}
            theme="dark"
        />
    );
}

const menu = [
    // { key: "student-content", label: "Kết nối học tập" },
    // { key: "student-new", label: "Trải nghiệm mới" },
    
];

const login_menu = [
    { key: "dashboard", label: "Dashboard" },
    { key: "student-enrollment", label: "Đăng ký môn" },
    { key: "student-courses", label: "Môn học của bạn" },
    { key: "student-calendar", label: "Lịch thi/kiểm tra" },
    { key: "student-posts", label: "Hỏi đáp" },
];

const teacherItems = [
    { key: "university-courses", label: "Quản lý Môn học" },
    { key: "university-tests", label: "Quản lý Bài kiểm tra" },
]

const universityItems = [
    { key: "university-tuition", label: "Quản lý Học phí" },
    { key: "university-majors", label: "Quản lý Ngành học" },
    { key: "university-students", label: "Quản lý Sinh viên" },
    { key: "university-teachers", label: "Quản lý Giảng viên" },
    { key: "university-terms", label: "Quản lý Kỳ học" },
];

const adminItems = [{ key: "ai-token", label: "AI Token" }];

function AdminMenu() {
    const { user } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const items = [
        ...(user?.role <= 1 ? universityItems : []),
        ...(user?.role <= 2 ? teacherItems : []),
        ...(user?.role === 0 ? adminItems : []),
    ];
    const { token } = useToken();
    return (
        items.length > 0 && (
            <div
                style={{ backgroundColor: token.colorPrimary }}
                className="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start"
            >
                <div
                    className="container admin-menu"
                    style={{ position: "relative" }}
                >
                    <ApartmentOutlined
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: 10,
                            transform: "translateY(-50%)",
                        }}
                    />
                    <Menu
                        items={items}
                        theme="dark"
                        selectedKeys={location.pathname}
                        onClick={(e) => {
                            navigate(e.key);
                        }}
                        mode="horizontal"
                        style={{
                            backgroundColor: "rgba(0,0,0,0)",
                            color: "white",
                        }}
                    />
                </div>
            </div>
        )
    );
}

export default function Header() {
    const navigate = useNavigate();
    const [buttonWidth, setButtonWidth] = useState(250);
    const buttonRef = useRef(null);
    const { user, logout } = useAuth();
    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                setButtonWidth(entry.contentRect.width);
            }
        });
        resizeObserver.observe(buttonRef.current);
    }, []);
    const final_menu = [...menu, ...(user ? login_menu : [])];
    return (
        <header className="bg-dark text-white sticky-top">
            <AdminMenu />
            <div className="container">
                <div className="p-1 d-flex flex-wrap align-items-center justify-content-center justify-content-md-start">
                    <Link
                        to="#"
                        className="d-flex align-items-center mb-2 mb-md-0 text-white text-decoration-none"
                    >
                        <img
                            className="hide-on-mobile"
                            alt="logo"
                            src={process.env.PUBLIC_URL + "/img/logo.png"}
                            width="40px"
                        />
                        {/* <img className='hide-on-desk' alt="logo" src={process.env.PUBLIC_URL + '/img/logongang-chu.png'} width="200px" /> */}
                    </Link>

                    <div
                        className="mb-md-0 header-menu"
                        style={{
                            marginRight: "auto",
                            width: `calc(100% - ${buttonWidth}px - 50px)`,
                        }}
                    >
                        <Navigation items={final_menu} />
                    </div>

                    <div className="text-end" ref={buttonRef}>
                        {user ? (
                            <>
                                <NotificationButton />
                                <Button
                                    type="primary"
                                    className="me-2"
                                    onClick={() => navigate("/account")}
                                >
                                    <UserOutlined /> {user?.first_name}
                                </Button>
                                <Button onClick={() => logout()}>
                                    <LogoutOutlined /> Logout
                                </Button>
                            </>
                        ) : (
                            <>
                                <Button
                                    type="primary"
                                    className="me-2"
                                    onClick={() => {
                                        navigate("/login");
                                    }}
                                >
                                    <LoginOutlined /> Đăng nhập
                                </Button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
}
